import cn from 'classnames';
import styles from './QuestionItem.module.scss';
import { QuestionType } from '@/types';
import { UserComment } from '@/atoms/UserComment';

type QuestionItemProps = {
  className?: string;
  question: QuestionType;
};

export function QuestionItem({ className, question }: QuestionItemProps) {
  const wrapperClassName = cn(styles.wrapper, className);

  return (
    <div className={wrapperClassName}>
      <div className={styles.header}>
        <UserComment isAnonymous={question.isAnonymous} user={question.user} />
        <span className={styles.date}>{question.date}</span>
      </div>
      <span className={styles.text}>{question.question}</span>
      <div className={styles.answer}>
        <span className={styles.answerTitle}>Ответ продавца</span>
        <span className={styles.answerText}>{question.answer}</span>
      </div>
    </div>
  );
}
